import { useMemo } from 'react';
import { InfiniteData } from '@tanstack/react-query';
import { useInfiniteQuery } from '@starsoft/common/services/query-client';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { fetchTimeFrames } from './service';
import { PaginatedResponse } from '@/models/pagination/paginated-response.dto';
import { UseTimeFramesQueryKeyProps } from './props';
import { TimeFramesQueryKey } from '../../queryKeys';
import { PaginatedRequest } from '@/models/pagination/paginated-request';
import { useInfiniteQueryCallbacks } from '@starsoft/common/hooks';
import { TimeFrame } from '@/models/time-frame';

export function useTimeFrames() {
  const filter: PaginatedRequest = {
    limit: 30,
  };
  const queryKey: UseTimeFramesQueryKeyProps = [
    TimeFramesQueryKey.Primary,
    filter,
  ];

  const infiniteQueryCallbacks = useInfiniteQueryCallbacks();

  const { data, isPending, error, refetch, ...rest } = useInfiniteQuery<
    PaginatedResponse<TimeFrame>,
    AxiosError<GenericError>,
    InfiniteData<PaginatedResponse<TimeFrame>>,
    UseTimeFramesQueryKeyProps
  >({
    queryKey,
    queryFn: fetchTimeFrames,
    staleTime: 5 * 1000,
    ...infiniteQueryCallbacks,
    initialPageParam: 1,
  });

  const timeFrames = useMemo(
    () => data?.pages.flatMap(page => page.data) ?? [],
    [data],
  );

  return {
    data,
    isPending,
    timeFrames,
    error,
    refetch,
    ...rest,
  };
}
